import n from "./ghl-ui.es1297.js";
import t from "./ghl-ui.es1298.js";
function f(a, r) {
  return a != null && t(a, r, n);
}
export {
  f as default
};
